// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import {
    productPartNumbersStyles,
    ProductPartNumbersStyles,
} from "@rugby/Overrides/Components/ProductPartNumbers.style";
import React, { FC } from "react";

interface OwnProps {
    productNumber: string;
    customerProductNumber?: string;
    manufacturerItem?: string;
    showCustomerName?: boolean;
    showManufacturerItem?: boolean;
    extendedStyles?: ProductPartNumbersStyles;
    showProductNumber?: boolean;
}

type Props = OwnProps;

const ProductPartNumbers: FC<Props> = props => {
    const {
        productNumber,
        customerProductNumber,
        manufacturerItem,
        showCustomerName = true,
        showManufacturerItem = true,
        extendedStyles,
        showProductNumber = true,
    } = props;
    const [styles] = React.useState(() => mergeToNew(productPartNumbersStyles, extendedStyles));
    const displayManufacturerNumber = showManufacturerItem && manufacturerItem;
    const displayCustomerNumber = showCustomerName && customerProductNumber;
    const numberOfItems = 1 + (displayManufacturerNumber ? 1 : 0) + (displayCustomerNumber ? 1 : 0);
    const mobileGridItemWidth = numberOfItems > 1 ? 6 : 12;
    const desktopGridItemWidth = 12 / numberOfItems;
    const gridWidth = [
        mobileGridItemWidth,
        mobileGridItemWidth,
        mobileGridItemWidth,
        mobileGridItemWidth,
        desktopGridItemWidth,
    ];
    const gridItemWidth = styles.condensed ? gridWidth : 12;

    return (
        <GridContainer {...styles.container}>
            {showProductNumber && (
                <GridItem width={gridItemWidth as GridWidths} {...styles.erpNumberGridItem}>
                    <Typography {...styles.erpNumberLabelText}>{translate("Part #: ")}&nbsp;</Typography>
                    <Typography {...styles.erpNumberValueText}>{productNumber}</Typography>
                </GridItem>
            )}
            {displayCustomerNumber && (
                <GridItem width={gridItemWidth as GridWidths} {...styles.customerNameGridItem}>
                    <Typography {...styles.customerNameLabelText}>{translate("My Part #: ")}&nbsp;</Typography>
                    <Typography {...styles.customerNameValueText} data-test-selector="customerProductNumber">
                        {customerProductNumber}
                    </Typography>
                </GridItem>
            )}
            {displayManufacturerNumber && (
                <GridItem width={gridItemWidth as GridWidths} {...styles.manufacturerItemGridItem}>
                    <Typography {...styles.manufacturerItemLabelText}>{translate("MFG #:")}&nbsp;</Typography>
                    <Typography {...styles.manufacturerItemValueText} data-test-selector="manufacturerItem">
                        {manufacturerItem}
                    </Typography>
                </GridItem>
            )}
        </GridContainer>
    );
};

export default ProductPartNumbers;
